import { PDF_FONTS_CONTRACT_MARK } from '@messenger/consts'
import { PagePrint } from '@/components/printPage/PagePrint'
import { PageProofWrapper } from '@/components/pdfRender/PageProofWrapper'
import * as S from '@/components/pdfRender/PdfRender.styled'
import type { PdfRenderProps } from '@/components/pdfRender/PdfRender'
import { combinesPages } from '@/utils/editor/combinesPages'
import { proofFoldMarksOf } from '@/components/pdfRender/proofFoldMarks'

export const PdfProofRender = ({
  backgroundType,
  concatenatedPages,
  data,
  isPDF,
  pages,
  proof,
  contextReady,
}: PdfRenderProps) => {
  const showSinglePage =
    combinesPages(concatenatedPages, data.original_layout) && pages?.length > 1
  const content = pages?.[0]
  const content2 = pages?.[1]
  // The legacy page that holds two pages draws only the middle mark its fold
  // line names; a trifold's folds are marked per page below.
  const {
    verticalCenter: showVerticalCenter,
    horizontalCenter: showHorizontalCenter,
  } = proofFoldMarksOf(data.original_layout)

  const nonClippedProducts = [
    'Register Book Pages',
    'Medium Signature Acknowledgement',
  ]
  const productBleedClipped = !nonClippedProducts.includes(
    String(data?.pages?.[0]?.content?.pageProperties?.product),
  )

  return (
    <S.Div
      className="divWrap"
      data-pdf-context-ready={contextReady ? 'true' : 'false'}
      {...PDF_FONTS_CONTRACT_MARK}
    >
      {showSinglePage ? (
        <PageProofWrapper
          key={`proof-page-${content?.pageProperties?.pageSetId}-${0}`}
          pageIndex={0}
          contentDimensions={{
            width: content?.pageProperties?.pageSize?.width || 612,
            height: content?.pageProperties?.pageSize?.height || 792,
          }}
          showVerticalCenter={showVerticalCenter}
          showHorizontalCenter={showHorizontalCenter}
          productBleedClipped={productBleedClipped}
        >
          <PagePrint
            page={content}
            secondPage={content2}
            theme={data.theme}
            themeOverride={data.theme_override?.[0]}
            index={0}
            proof={proof}
            isPDF={isPDF}
            backgroundType={backgroundType}
            orderId={data.order?.id}
            pageSetId={data.page_set?.id}
            originalLayout={data.original_layout}
            baseLayout={data.layout}
            nonClippedProducts={nonClippedProducts}
          />
        </PageProofWrapper>
      ) : (
        pages.map((page, index) => {
          const pageMarks = proofFoldMarksOf(
            data.original_layout,
            page?.pageProperties?.pageNumber,
            page?.pageProperties?.pageSize?.width,
          )
          return (
            <PageProofWrapper
              key={`proof-wrapper-${page?.pageProperties?.pageSetId}-${index}`}
              pageIndex={index}
              contentDimensions={{
                width: page?.pageProperties?.pageSize?.width || 612,
                height: page?.pageProperties?.pageSize?.height || 792,
              }}
              showVerticalCenter={pageMarks.verticalCenter}
              showHorizontalCenter={pageMarks.horizontalCenter}
              foldMarks={pageMarks.folds}
              productBleedClipped={productBleedClipped}
            >
              <PagePrint
                page={page}
                secondPage={undefined}
                theme={data.theme}
                themeOverride={data.theme_override?.[0]}
                index={index}
                proof={proof}
                isPDF={isPDF}
                backgroundType={backgroundType}
                orderId={data.order?.id}
                pageSetId={data.page_set?.id}
                originalLayout={data.original_layout}
                baseLayout={data.layout}
                nonClippedProducts={nonClippedProducts}
              />
            </PageProofWrapper>
          )
        })
      )}
    </S.Div>
  )
}
